import React, { useState } from 'react'

// mui
import { TableRow, TableCell, Collapse, IconButton, Box, Table, Typography, TableHead, TableBody } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'

const CollapsibleTableRow = ({ row }) => {
    const [open, setOpen] = useState(false)

    return (<React.Fragment>
        <TableRow key={row.key}>
            <TableCell>
                <IconButton
                    size="small"
                    onClick={() => setOpen(!open)}
                >
                    { open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon /> }
                </IconButton>
            </TableCell>
            <TableCell component="th" scope="row">
                {row.name}
            </TableCell>
            {
                row.mainCells.map(cell => {
                    return (<TableCell align="right" key={cell.key}>{cell.value}</TableCell>)
                })
            }
        </TableRow>

        {/* Collapsible table */}
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0, backgroundColor: '#FCF9F9' }} colSpan={row.mainCells.length + 2}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1}}>
                        {/* <Typography variant="h6" gutterBottom component="div">
                            Logs
                        </Typography> */}
                        <Table size="small">
                            {/* <TableHead>
                                <TableRow>
                                    {
                                        row.collapseTable.headers.map(header => {
                                            return (<TableCell key={header.key}>{header.value}</TableCell>)
                                        })
                                    }
                                </TableRow>
                            </TableHead> */}
                            <TableBody>
                                {
                                    row.collapseTable.rows.map(row => {
                                        return (<TableRow key={row.key}>
                                            {
                                                row.cells.map(cell => {
                                                    return (<TableCell key={cell.key}>{cell.value}</TableCell>)
                                                })
                                            }
                                        </TableRow>)
                                    })
                                }
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>

    </React.Fragment>)

}

export default CollapsibleTableRow